import React, { useContext, useReducer } from "react";
// import React, { useContext } from "react";
// import { useReducer } from "reinspect";
import { ScheduleContext } from "../App/ScheduleContext";
import reducer, { CALCULATION_SCREEN, SCHEDULE_SELECT_SCREEN, STAGE_DISPLAY_SCREEN, STAGE_SELECT_SCREEN, initialState } from "./reducer";
import Layout from './Layout';
import Stage from "../../components/Stage/Stage";
import PropTypes, { InferProps } from 'prop-types';
import setSchedule, { toggleStage, setScreen, setQuantity, toggleCategory } from "./actions"
import CalculationOutput from "../../components/CalculationOutput/CalculationOutput";
import ScheduleSelection from "../../components/ScheduleSelection/ScheduleSelection";
import StageSelection from "../../components/StageSelection/StageSelection";

const propTypes = {
  topRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(Element) })
  ])
};

export default function Screen(props: InferProps<typeof propTypes>): JSX.Element {
  const { topRef } = props;

  const scheduleData = useContext(ScheduleContext);
  const [state, dispatch] = useReducer(reducer, { ...initialState, schedules: [...scheduleData] });
  // const [state, dispatch] = useReducer(reducer, {...initialState, schedules: [...scheduleData]}, (a)=>a, 'IDofReducer');

  function calculateProgress() {
    let progress = 0;
    switch (state.screen.type) {
      case (SCHEDULE_SELECT_SCREEN):
        progress = 0;
        break;
      case (STAGE_SELECT_SCREEN):
        progress = 25;
        break;
      case (STAGE_DISPLAY_SCREEN):
        progress = 25 + ((55 / state.activeStages.length) * (state.screen.index + 1));
        break;
      case (CALCULATION_SCREEN):
        progress = 100;
        break;
      default: {
        throw Error('Unknown screen type: ' + state.screen.type);
      }
    }
    return progress;
  }

  function hideBackButton() : boolean {
    if (state.screen.type === SCHEDULE_SELECT_SCREEN) {
      return true;
    }
    return false;
  }

  function hideForwardButton() : boolean {
    if (state.screen.type === CALCULATION_SCREEN) {
      return true;
    }
    return false;
  }
  function enableBackButton() {
    if (state.screen.type === SCHEDULE_SELECT_SCREEN
      || state.errorState === true) {
      return false;
    }
    return true;
  }

  function enableNextButton() {
    if ((state.screen.type === SCHEDULE_SELECT_SCREEN && !state.activeSchedule)
      || (state.screen.type === STAGE_SELECT_SCREEN && !state.activeStages.length)
      || state.errorState === true) {
      return false;
    }
    return true;
  }

  function isChecked(categoryID) {
    return state.activeCategories.find(category => category.categoryID === categoryID)
      ? true
      : false;
  }

  function isActive(scheduleID) : boolean {
    return state.activeSchedule?.id === scheduleID;
  }

  function scroll() {
    state.screen.scroll ? topRef.current?.scrollIntoView({ behavior: 'smooth' }) : null;
  }

  function switchScreen() {
    const { type, index } = state.screen;
    let result = null;

    switch (type) {
      case SCHEDULE_SELECT_SCREEN:
        result =
          <ScheduleSelection
            schedules={state.schedules}
            setSchedule={(scheduleID) => setSchedule(dispatch, scheduleID)}
            isActive={(scheduleID) => isActive(scheduleID)}
            key='schedule_selection'
          />
        break;
      case STAGE_SELECT_SCREEN:
        result =
          <StageSelection
            stages={state.activeSchedule.stages}
            activeStages={state.activeStages}
            toggleStage={(stageID) => toggleStage(dispatch, stageID)}
          />
        break;
      case CALCULATION_SCREEN:
        result =
          <CalculationOutput
            activeCategories={state.activeCategories}
            activeStages={state.activeStages}
            scheduleName={state.activeSchedule.name}
            scheduleGroup={state.activeSchedule.group}
            calculation={state.calculation}
            scroll={() => scroll()}
          />
        break;
      case STAGE_DISPLAY_SCREEN:
        let stage = state.activeStages[state.screen.index];
        result =
          <Stage
            name={stage.name}
            subStages={stage.subStages}
            isChecked={(categoryID) => isChecked(categoryID)}
            setQuantity={(categoryID, feeQuantity) => setQuantity(dispatch, categoryID, feeQuantity)}
            toggleCategory={(categoryID) => toggleCategory(dispatch, categoryID)}
            key={stage.name + stage.id}
            scroll={() => scroll()}
          />
        break;
      default: {
        throw Error('Unknown screen: ' + type + ' with index: ' + index);
      }
    }

    return result;
  }

  return (
    <>
      <Layout
        progress={calculateProgress()}
        setSchedule={state.screen.type !== SCHEDULE_SELECT_SCREEN ? () => setSchedule(dispatch, null) : null}
        scheduleTitle={state.activeSchedule?.name ?? "Schedule"}
        hideBackBtn={hideBackButton()}
        hideForwardBtn={hideForwardButton()}
        handleBack={enableBackButton() ? () => setScreen(dispatch, -1) : null}
        handleNext={enableNextButton() ? () => setScreen(dispatch, 1) : null}
      >
        {switchScreen()}
      </Layout>
    </>
  );
}
